export default __webpack_public_path__ + "0dcc1122a8bd94251b1778c8d146cfd5.png";